import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActionComponent } from './action.component';
import { ActionFormComponent } from './action-form/action-form.component';
import { ActionCreateComponent } from './action-create/action-create.component';
import { ActionEditComponent } from './action-edit/action-edit.component';
import { ActionIndexComponent } from './action-index/action-index.component';
import {CardModule} from '../../resources/components/card/card.module';
import {FormGroupContextModule} from '../../resources/modules/form-group-context/form-group-context.module';
import {FormGroupSimpleModule} from '../../resources/modules/form-group-context/form-group-simple/form-group-simple.module';
import {ValidateModule} from '../../resources/modules/validate/validate.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {ActionRoutesModule} from './action-routes/action-routes.module';
import {TableActionModule} from '../../resources/tables/table-action/table-action.module';
import {FormGroupSelectModule} from '../../resources/modules/form-group-context/form-group-select/form-group-select.module';
import {BtnDeleteModule} from "../../resources/components/btn-delete/btn-delete.module";



@NgModule({
  declarations: [ActionComponent, ActionFormComponent, ActionCreateComponent, ActionEditComponent, ActionIndexComponent],
  imports: [
    CommonModule,
    CardModule,
    RouterModule,
    ActionRoutesModule,
    FormGroupContextModule,
    FormGroupSimpleModule,
    ValidateModule,
    FormsModule,
    ReactiveFormsModule,
    TableActionModule,
    FormGroupSelectModule,
    BtnDeleteModule,
  ]
})
export class ActionModule { }
